// RoomCardBoutique.jsx - Tarjeta minimalista para búsqueda de habitaciones
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMXN } from '../../services/roomData';
import '../css/RoomCardBoutique.css';

const RoomCardBoutique = ({ room, onViewDetails }) => {
  const { t } = useTranslation();
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const isAvailable = room.status !== 'unavailable';
  
  return (
    <div className={`room-card-boutique ${!isAvailable ? 'unavailable' : ''}`}>
      <div className="image-wrapper-boutique">
        {room.images && room.images[0] ? (
          <img
            src={room.images[0]}
            alt={room.name}
            className={imageLoaded ? 'loaded' : ''}
            onLoad={() => setImageLoaded(true)}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="placeholder-boutique" />
        )}
        {!isAvailable && <div className="overlay-unavailable">No disponible</div>}
      </div>
      
      <div className="info-wrapper-boutique">
        <h3 className="room-name-boutique">{room.name}</h3>
        <div className="room-meta-boutique">
          <span>👥 {room.capacity} personas</span>
          <span>📐 {room.size}</span>
        </div>
        <div className="price-wrapper-boutique">
          <span className="price-boutique">{formatMXN(room.price)}</span>
          <span className="period-boutique">/noche</span>
        </div>
        <button 
          className={`btn-boutique ${!isAvailable ? 'disabled' : ''}`}
          onClick={() => isAvailable && onViewDetails(room)}
          disabled={!isAvailable}
        >
          {isAvailable ? t('roomCard.moreInfo') : 'No disponible'}
        </button>
      </div>
    </div>
  );
};

export default RoomCardBoutique;